export class Storage {
    constructor() {
    }

    static getStorageItem(key: string, useSessionStorage = false): string | null {
        if (!useSessionStorage) {
            return localStorage.getItem(key);
        }

        return sessionStorage.getItem(key);
    }

    static setStorageItem(key: string, data: string, useSessionStorage = false): void {
        try {
            if (!useSessionStorage) {
                localStorage.setItem(key, data);
            } else {
                sessionStorage.setItem(key, data);
            }
        } catch (e) {
        }

    }

    static removeStorageItem(key: string, useSessionStorage = false): void {
        if (!useSessionStorage) {
            localStorage.removeItem(key);
        } else {
            sessionStorage.removeItem(key);
        }
    }
}
